import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
// src/components/QrcodeFill.tsx
const QrcodeFillIcon = ZepIcon((props) => /* @__PURE__ */ jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.1 12.9a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1H4l-.103-.005A1 1 0 0 1 3 20v-6.1a1 1 0 0 1 .897-.995L4 12.9h6.1Z",
			fill: props.fill || "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M14.599 18.3a1 1 0 0 1 1 1v.7a1 1 0 0 1-1 1h-.7a1 1 0 0 1-1-1v-.7a1 1 0 0 1 1-1h.7ZM20.001 18.3a1 1 0 0 1 1 1v.7a1 1 0 0 1-1 1h-.7a1 1 0 0 1-1-1v-.7a1 1 0 0 1 1-1h.7ZM17.302 15.6a1 1 0 0 1 1 1v.7a1 1 0 0 1-1 1h-.7a1 1 0 0 1-1-1v-.7a1 1 0 0 1 1-1h.7ZM14.599 12.9a1 1 0 0 1 1 1v.7a1 1 0 0 1-1 1h-.7a1 1 0 0 1-1-1v-.7a1 1 0 0 1 1-1h.7ZM20.001 12.9a1 1 0 0 1 1 1v.7a1 1 0 0 1-1 1h-.7a1 1 0 0 1-1-1v-.7a1 1 0 0 1 1-1h.7Z",
			fill: props.fill || "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.1 3a1 1 0 0 1 1 1v6.1a1 1 0 0 1-1 1H4l-.103-.005A1 1 0 0 1 3 10.1V4a1 1 0 0 1 .897-.995L4 3h6.1ZM19.998 3a1 1 0 0 1 1 1v6.1a1 1 0 0 1-1 1h-6.1l-.102-.005a1 1 0 0 1-.898-.995V4a1 1 0 0 1 .898-.995L13.898 3h6.1Z",
			fill: props.fill || "currentColor"
		})
	]
}));
export { QrcodeFillIcon };
